import { render, staticRenderFns } from "./BulkInfrastructureUpgradeStarTableRow.vue?vue&type=template&id=871f45f4&scoped=true&"
import script from "./BulkInfrastructureUpgradeStarTableRow.vue?vue&type=script&lang=js&"
export * from "./BulkInfrastructureUpgradeStarTableRow.vue?vue&type=script&lang=js&"
import style0 from "./BulkInfrastructureUpgradeStarTableRow.vue?vue&type=style&index=0&id=871f45f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871f45f4",
  null
  
)

export default component.exports